import React, { useEffect, useState } from "react";
import DivisionCmp from "../../../components/cards/DivisionCmp";

import * as Converter from "persian-currency-converter";
import { InfoCheque } from "../../../models/loan.model";
import { SectionModel } from "../../../models/components.model";
import DetailInfoComponent from "../../../components/detailInfo/detailInfoComponent";

interface SchemaInfoModel {
  data?: InfoCheque[];
}
function _InstallmentInfo({
  data,
  index,
  file,
  rearFile,
}: {
  data: SchemaInfoModel;
  index: Number;
  file: any;
  rearFile: any;
}) {
  const sections: SectionModel[] = [
    {
      dataKey: "amount",
      rowCol: 4,
      title: " مبلغ به عدد (ریال)",
      dataPostValue: "ریال",
      hasThousandSeparatorFormat: true,
    },
    { dataKey: "expectedHolder", rowCol: 4, title: "در وجه" },
    { dataKey: "bankName", rowCol: 4, title: " بانک" },
    { dataKey: "expectedIdCode", rowCol: 4, title: "شناسه ملی" },
    { dataKey: "dueDatePersian", rowCol: 4, title: "تاریخ سررسید" },
    {
      dataKey: "inquiryDueDatePersian",
      rowCol: 4,
      title: "تاریخ سررسیداستعلام شده",
    },
    { dataKey: "signer", rowCol: 4, title: "امضاء کننده" },
    { dataKey: "seriesNo", rowCol: 4, title: "شماره سری  چک" },
    { dataKey: "serialNo", rowCol: 4, title: "شماره سریال چک" },
    { dataKey: "sayadNumber", rowCol: 4, title: "شماره صیادی" },
    { dataKey: "fromIban", rowCol: 4, title: "شماره  شبا" },
    {
      dataKey: "branchCode",
      rowCol: 4,
      title: "کد شعبه صادر کننده ",
      // dataPostValue: "----------",
    },
    { dataKey: "reasonTitle", rowCol: 6, title: "توضیحات" },
  ];
  let fileArray: any[] = [];
  fileArray.push(file);
  fileArray.push(rearFile);
  return (
    <DetailInfoComponent
      sections={sections}
      data={data}
      documentInfo={fileArray}
      marginRight={"-2vh"}
      marginLeft={"-4vh"}
      showFooter={false}
    />
  );
}

export default function InstallmentInfo({ data }: SchemaInfoModel) {
  const child = (
    <>
      {data?.map((item: any, index: number) => (
        <div className="cardTabBorder cardTabBorderShadow cardTabBorderMargin borderCOlor mbottom5">
          <p
            className="cardtitle"
            style={{
              marginTop: "-1.7vh",
              backgroundColor: "#fff",
              width: "fit-content",
            }}
          >
            {" "}
            چک شماره {Converter.convertToPersianWord(++index)}
          </p>
          <_InstallmentInfo
            data={item}
            index={++index}
            file={item.file}
            rearFile={item.rearFile}
          />
          {/* <_InstallmentInfo data={item} index={++index} file={fileArray} /> */}
          {/* <DocumentInfoComponentSingle data={item.file} /> */}
        </div>
      ))}
    </>
  );

  return (
    // <div className="cardTabBorder cardTabBorderShadow borderCOlor" style={{ backgroundColor:  "#fff", margin:  "" }}>
    <>{child}</>
  );

  // </div>);
  // return <DivisionCmp child={child} title={"جزییات مدرک ضمانت"} />;
}
